import { ReturnUserReadable } from '@crm/api'
import { Avatar, Text } from '@shared/components'

import { getFullName, getUserInitials, intoRGB } from '@shared/utils'

import { Flex, Tooltip } from 'antd'

type Props = {
  user: ReturnUserReadable
  label: string
}

export const ActivityLogAvatar = ({ user, label }: Props) => {
  if (!user) return null

  return (
    <Flex gap={4} justify="end" align="center">
      <Text weight={500}>{label}: </Text>

      {user && (
        <Tooltip title={getFullName(user)}>
          <Avatar
            avatarProps={{
              icon: null,
              size: 'small',
              style: { backgroundColor: intoRGB(getFullName(user)) }
            }}
          >
            {getUserInitials(user)}
          </Avatar>
        </Tooltip>
      )}
    </Flex>
  )
}
